import api from '../utils/api';


// Actions
const SET_LAST_UPDATE = 'ORDERS/SET_LAST_UPDATE';

// Initial state for reducer
const initialState = {
    lastUpdate: null,
};

// Reducer(s)
export default function ordersReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LAST_UPDATE:
            return {
                lastUpdate: action.lastUpdate,
            };
        default:
            return state;
    }
}

// Action creators
const setLastUpdate = lastUpdate => ({type: SET_LAST_UPDATE, lastUpdate});

export const updateLastUpdateTimestamp = () => (dispatch) => {
    api.salesOrdersLastUpdate.fetch().then(
        (data) => {
            dispatch(setLastUpdate(data.last_update));
        },
        console.error,
    );
};

export const updateSalesOrders = () => (dispatch) => {
    /* 1) Fetch current last update timestamp
     * 2) Run the task again
     * 3) Poll last update timestamp changes while it actually changes
     */
    const pollInterval = 5000;
    const lastUpdateCheck = (lastUpdate) => {
        api.salesOrdersLastUpdate.fetch().then(
            (data) => {
                if (data.last_update !== null && data.last_update !== lastUpdate) {
                    dispatch(setLastUpdate(data.last_update));
                } else {
                    setTimeout(lastUpdateCheck, pollInterval, lastUpdate);
                }
            },
            console.error,
        );
    };

    api.salesOrdersLastUpdate.fetch().then(
        (data) => {
            const lastUpdate = data.last_update;
            api.salesOrdersRefresh.post().then(
                () => {
                    setTimeout(lastUpdateCheck, pollInterval, lastUpdate);
                },
                console.error,
            );
        },
        console.error,
    );
};



// WEBPACK FOOTER //
// ./src/ducks/orders.js